import { createIntl, createIntlCache } from 'react-intl';
import renderLocale from '../helpers/renderLocale';
import { Components } from '../../global.d';
import messages from '../../assets/messages';

export interface IRetailTradeSpec {
  id: string;
  label: string;
  value: string;
  icon: string;
}

const locale = renderLocale();
const intl = createIntl(
  { locale, messages: messages[locale] },
  createIntlCache()
);

class RetailTradeDetails {
  specifications: IRetailTradeSpec[];

  constructor(data: Components.Schemas.RetailTradeDto) {
    this.specifications = data
      ? [
          {
            label: intl.formatMessage({ id: 'vdp.retail.kilometres' }),
            value: data.odometerDisplay,
            id: 'kilometres',
            icon: 'dash-icon'
          },
          {
            label: intl.formatMessage({ id: 'vdp.retail.transmission' }),
            value: data.transmission,
            id: 'transmission',
            icon: 'Transmission-icon'
          },
          {
            label: intl.formatMessage({ id: 'vdp.retail.engine' }),
            value: data.engine,
            id: 'engine',
            icon: 'engine-icon'
          },
          {
            label: intl.formatMessage({ id: 'vdp.retail.drivetrain' }),
            value: data.driveTrain,
            id: 'drivetrain',
            icon: 'TR5-Drive_train'
          },
          {
            label: intl.formatMessage({ id: 'vdp.retail.fuelType' }),
            value: data.fuelType,
            id: 'fuelType',
            icon: 'fuel-icon'
          },
          {
            label: intl.formatMessage({ id: 'vdp.retail.seats' }),
            value: data.seats.toString(),
            id: 'seats',
            icon: 'TR5-Vehicle-Seat'
          },
          {
            label: intl.formatMessage({ id: 'vdp.retail.exteriorInterior' }),
            value: data.extIntColor,
            id: 'extIntColour',
            icon: 'colour-icon'
          }
        ]
      : [];
  }
}

export default RetailTradeDetails;
